module.exports = __webpack_public_path__ + "static/media/coronakit_tn.019fc186.png";